const jp = {
  copySuccess: 'アドレスコピー成功',
  copyError: 'コピーに失敗しました。再試行してください！',
  noRecord: '記録なし',
  color: '色',
  price: '価格',
  time: '時間',
  success: '成功',
  fail: '失敗',
  titleText: '天空の城クラブ',
  copy: 'アドレスのコピー',
  balance: '残高',
  buy: '購入する',
  loadingText: 'ロード中...',
  connectText: `本当に{wallet}をインストールしますか？`,
  lastPage: '前のページはありません',
  nextPage: '次のページはありません',
  notOpen: 'まだオープンしていません',
  name: 'かやぶきの家',
  notIn: '販売予想に達していない',
  enter: 'DAPPへ',
  information: 'ソーシャルメディア',
  loveText: '君はもうほめたよ。',
  skytBal: 'SKYT残高不足!',
  usdtBal: 'USDT残高不足!',
  Nav: {
    home: 'ホーム',
    market: '市場',
    nft: '私のNFT',
    exchange: '両替',
    account: '私のアカウント',
    connect: 'ウォレットの接続',
    pledge: '抵当に入れる',
  },
  Account: {
    title: '私のアカウント',
    title2: '私の招待',
    inviteTitle: '友達を招待する',
    bindSuccess: 'バインド成功',
    bindTitle: '親のバインド',
    copy: 'リンクのコピー',
    bind: 'バインド',
    bindIng: 'バインド中...',
    assets: '総資産',
    address: '親の住所を入力してください',
    total: '総収益',
    income: '帰任を招請する',
    parent: '親',
    bindBtn: '招待住所を記入する',
    invitePerson: '普及人数',
    invite: 'に勧める',
    record1: '収益ログ',
    record2: '私の仲間',
    code: '招待コード：',
    parentAlert: 'まず上司をバインドしてください！',
    nav: {
      one: '収益タイプ',
      two: '収益',
      three: '売り出す',
      four: '広める',
      five: 'アドレス',
      six: '登録時間',
      seven: '元金',
    },
  },
  Swap: {
    number: '両替数量を入力してください',
    btn: '両替',
    type1: `{usdt} USDT 両替 {token} SKYT`,
    type2: `{token} SKYT 両替 {usdt} USDT`,
  },
  AccountTransfer: {
    link: 'BSCブラウザでの表示',
    transfer: '最近の取引',
    clear: '（すべてクリア）',
    account: 'アカウント',
    record: 'あなたの取引はここに現れます…',
  },
  HashType: {
    one: 'LANDを購入',
    two: 'LANDを販売',
    three: 'USDT 両替 SKYT',
    four: 'SKYT 両替 USDT',
    five: 'LANDを修正する',
    six: 'LANDをキャンセル',
  },
  SwapAlert: {
    title1: 'ユーザー交換',
    title2: 'ユーザーのキャンセル',
    title3: 'ユーザー取引',
    title4: 'ユーザーの変更',
    title5: 'ユーザー購入',
    title6: 'ユーザー販売',
    success1: '両替成功',
    success2: 'キャンセル成功',
    success3: '取引成功',
    success4: '変更に成功しました',
    btn1: '両替中...',
    btn2: 'キャンセル中...',
    btn3: '取引中...',
    btn4: '変更中...',

    close: 'オフ',
  },
  PixelItem: {},
  EmpowerAlert: {
    one: `Marketがあなたの#{tokenId}NFTを呼び出すことを許可します。`,
    two: 'Market契約によるUSDTの呼び出しを許可',
    three: 'NFT契約によるSKYTの呼び出しを許可',
    four: 'Market契約でSKYTを呼び出すことができます。',
    btn1: '承認中...',
    btn2: '承認NFT',
    btn3: 'USDTのライセンス',
    btn4: 'SKYTのライセンス',
    title: 'ユーザー認証',
  },

  Home: {
    title: '鋳造LAND',
    title1: 'ビデオ',
    title2: 'パートナー',
    text1: '天空の城ラピュタ',
    text2:
      '「Cityinthesky」の元宇宙はLANDで構成され、LANDを持っているプレイヤーはそれを利用して創作を行い、収益を得ることができます。利用できるLANDの数は永遠に90000元で、ゲームを開催したり、複数人のゲーム体験を作ったり、家を建てたり、コミュニティに社交体験を提供したりすることができます。',
    text3: '20天空の城ラピュタ',
    text4: '色を選択',
    text5: '1.描画するピクセルを選択',
    text6: 'いらっしゃいませ',
    text7: '天空の城クラブ',
    text8:
      '古い帝国ラビダは空に浮かぶ巨大な機械島で、そこにはもう誰も住んでいないと言われていて、大きな富を秘めています。そのため、軍も海賊も、この伝説の飛行島を探しています。鉱山労働者のパーカーはこの日、ラビダの後継者シータに偶然会った。二人は一見旧知のようだ。シータにはラビダ帝国を探す重要な物体の飛行石があり、軍と海賊の2人の人馬がシータを追いかけているからだ。パーカーはシータを連れて一緒に逃亡し、最終的には軍の手から脱出できず、シータは軍にさらわれた。友達を救うために、パーカーは海賊と協力するしかない。パーカーと海賊はシータを救出することに成功した。同時に、彼らも軍の邪悪な計画を発見した。軍の邪悪な計画の実施を阻止するために、彼らは海賊と一緒にラビダを探す旅に出た。',
    text9: '市場に入る',
    text10: 'NFTとは？',
    text11:
      '非同質化トークン（NFT）はブロックチェーン上に貯蔵された仮想トークンであり、数字希少性・安全性・真実性などの特徴を持っている。それらは唯一無二で、分割できず、互換性がなく、ゲーム内の資産が本当にデジタル所有権を持つことができます。',
    text12: `ユーザー{start}...{end}がNFTを購入しています`,
    text13:
      '「Cityintehsky」の仮想メタ宇宙では、プレイヤーは遊び、仮想体験を使用して収益を得ることができます。あなたの闇号化通貨を投資に使用して、より多くのGOLDを得ることができます。',
    alert1: 'まず画素ブロックを選択してください',
    alert2: 'すべて鋳造済み!',
    btn1: 'LANDを購入',
    btn2: 'ただちに質押する',
    likes: 'いいねを押す',
  },
  Market: {
    text: '古い帝国ラビダは空に浮かぶ巨大な機械島で、そこにはもう誰も住んでいないと言われていて、大きな富を秘めています。そのため、軍も海賊も、この伝説の飛行島を探しています。鉱山労働者のパーカーはこの日、ラビダの後継者シータに偶然会った。二人は一見旧知のようだ。シータにはラビダ帝国を探す重要な物体の飛行石があり、軍と海賊の2人の人馬がシータを追いかけているからだ。パーカーはシータを連れて一緒に逃亡し、最終的には軍の手から脱出できず、シータは軍にさらわれた。友達を救うために、パーカーは海賊と協力するしかない。パーカーと海賊はシータを救出することに成功した。同時に、彼らも軍の邪悪な計画を発見した。軍の邪悪な計画の実施を阻止するために、彼らは海賊と一緒にラビダを探す旅に出た。',
    nav: {
      one: '商品',
      two: '床価格',
      three: '最新価格',
      four: '購入者',
      five: '取引時間',
    },
    alert: '自分のリストを購入することはできません！',
    seller: '所有者',
    seeMore: '詳細を読む',
    down: 'しまっておく',
    record: 'レコード枚',
    type1: '時間ソート',
    type2: '価格ソート',
  },
  NFT: {
    tabs: {
      one: '保有中',
      two: '売り出し中',
      three: '購入済み',
    },
    type1: `ユーザー{start}...{end}がアップフレーム中{tokenId}NFT`,
    type2: `ユーザー{start}...{end}アップフレームをキャンセルしています#{tokenId}NFT`,
    type3: `ユーザー{start}...{end}は#{tokenId}NFTを修正しています。`,
    changeColor: '置換色を選択',
    modity: '変更の確認',
    notice: '販売時にプラットフォームは8%の手数料を抽出します。',
    cancel: '売却を取り消す',
    sell: '売り出す',
    moditySuccess: '変更に成功しました',
    counts: '成約回数：',
    notSell: '販売不可',
  },
  Propaganda: {
    text1:
      '各NFT家屋はユニークで、屋根、木、窓など170種類の可能な特徴からプログラミングで生成されます。',
    text2:
      'すべての家はすごいですが、他の人より珍しいものもあります。すべてのNFTはBSCブロックチェーンに格納され、IPFSにホスティングされます。',
  },
};

export default jp;
